/**
 * The IdDocumentType the capture flow is started with when this screen did not collect one,
 * because the vendor's own capture app asks for it instead. Deliberately not a member of
 * IdvDocuments: it is never offered to a participant, it is what the API is told.
 */
export const UNKNOWN_DOCUMENT_TYPE = 'Unknown';

export const IdvDocuments: { [key: string]: IdvDocumentDisplay }  = Object.freeze({
    NorthAmericanDriversLicense: {
        value: 'NaDriversLicense',
        display: "Driver's License or ID Card",
    },
    Passport:{
        value: 'Passport',
        display: 'Passport',
    },
    UsPassportCard:{
        value: 'UsPassportCard',
        display: 'US Passport Card',
    },
    Other:{
        value: 'Other',
        display: 'Other',
    },
});

export interface IdvDocumentDisplay {
    value: string,
    display: string
}
